import Vue from 'vue';
import VueRouter from 'vue-router';
import Store from '../store/index.js';
import { EstablishmentSetting } from '@/enums';
import { useRouter } from './useRouter.js';

const utils = useRouter();

Vue.use(VueRouter);

const Router = new VueRouter({
    // The order of the route is important: the earlier a route is defined, the higher priority it gets
    routes: [
        {
            path: '/not-found',
            name: 'not-found',
            component: () => import('../pages/NotFound.vue'),
        },
        {
            path: '*',
            redirect: '/not-found',
        },
        {
            path: '/:establishmentId',
            name: 'home',
            redirect: '/take-appt',
            component: () => import('../pages/Home.vue'),

            beforeEnter: utils.beforeEnter,
            children: [
                {
                    path: '/:establishmentId',
                    redirect: 'take-appt',
                },
                {
                    path: 'take-appt',
                    name: 'take-appt',
                    meta: { title: { fr: 'Prendre un rendez-vous', en: 'Appointment booking' } },
                    component: () => import('../pages/TakeAppt.vue'),
                    beforeEnter: async(to, from, next) => {
                        await Promise.all([
                            Store.dispatch('services/getAllMetaData'),
                            Store.dispatch('globalSettings/fetchGlobalSettings'),
                        ]);

                        next();
                    },
                },
                {
                    path: 'cancel-appt',
                    name: 'cancel-appt',
                    meta: { title: { fr: 'Annuler un rendez-vous', en: 'Cancel an appointment' } },
                    component: () => import('../pages/CancelAppt.vue'),
                },
                {
                    path: 'join',
                    name: 'join',
                    meta: { title: { fr: 'Nous joindre', en: 'Contact us' } },
                    component: () => import('../pages/Join.vue'),
                    beforeEnter: async(to, from, next) => {
                        const establishment = Store.getters['establishment/getEstablishment'];
                        const showContactSetting = Store.getters['establishment/getEstablishmentSettingById'](EstablishmentSetting.SHOW_CONTACT_US_PUBLIC_PAGE);
                        if (showContactSetting && establishment.email) {
                            next();
                        }
                        else {
                            next('/' + establishment.id);
                        }
                    },
                },
                {
                    path: 'confirm-appt',
                    name: 'confirm-appt',
                    meta: { title: { fr: 'Confirmation de rendez-vous', en: 'Appointment confirmation' } },
                    component: () => import('../pages/ConfirmAppt.vue'),
                },
                {
                    path: 'coupon',
                    name: 'coupon',
                    meta: { title: { fr: 'Coupon de rendez-vous', en: 'Appointment ticket' } },
                    component: () => import('../pages/Coupon.vue'),
                },
            ],
        },
    ],
    mode: 'history',
});

// Validate auth before accessing routes
Router.beforeEach(utils.beforeEach);

Router.afterEach(async(to, from) => {
    // remove loading
    if (Store.getters['loading/isHomeLoading']) {
        await Store.dispatch('loading/toggleHomeLoading', { set: false });
    }
});

export default Router;
